<template>
    <div v-if="additionals">
        <div v-if="additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-data-table
                :fields="fields"
                :repository="repositories.baixa"
                ref="DataTableBaixa"
                search-by="vacinaNome"
            >
                <template v-slot:cell(actions)="row">
                    <rkm-button
                        :disabled="row.item.estoque == 0"
                        @click="$refs.ModalBaixa.open(row.item)"
                        authorize="create-imunizacao-baixa"
                        color="primary"
                        small
                        title="Nova baixa"
                    >
                        <rkm-icon icon="share" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="$refs.ModalHistorico.open(row.item)"
                        authorize="reverse-almoxarifado-baixa"
                        color="secondary"
                        small
                        title="Histórico de baixa"
                    >
                        <rkm-icon icon="history" />
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalIndisponibilidade.open(row.item)"
                        authorize="create-imunizacao-baixa"
                        color="warning"
                        small
                        title="Estoques indisponíveis"
                    >
                        <rkm-icon icon="ban" />
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalEstorno.open(row.item)"
                        authorize="create-imunizacao-baixa"
                        color="danger"
                        small
                        title="Novo estorno"
                    >
                        <rkm-icon icon="undo-alt" />
                    </rkm-button>
                </template>
            </rkm-data-table>

            <ModalBaixa
                @save="$refs.DataTableBaixa.refresh()"
                ref="ModalBaixa"
            />


            <ModalHistorico
                ref="ModalHistorico"
            />

            <ModalIndisponibilidade
                @save="$refs.DataTableBaixa.refresh()"
                ref="ModalIndisponibilidade"
            />

            <ModalEstorno
                @save="$refs.DataTableBaixa.refresh()"
                ref="ModalEstorno"
            />
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar uma baixa.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalBaixa from './components/baixa/Modal'
import ModalEstorno from './components/estorno/Modal'
import ModalIndisponibilidade from './components/indisponibilidade/Modal'
import ModalHistorico from './components/historico/Modal'
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, permissao, repository } from '@/mixins'

// Vuex.
import { mapActions,mapGetters } from 'vuex'

export default {
    components: {
        ModalBaixa,
        ModalEstorno,
        ModalIndisponibilidade,
        ModalHistorico
    },
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            const fields = [
                { key: 'vacinaNome', label: 'Nome da vacina', name: 'vacina_nome', searchable: true, sortable: true },
                { key: 'unidadeNomeFantasia', label: 'Unidade', name: 'unidade_nome_fantasia', searchable: true, sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', name: 'infraestrutura_nome', searchable: true, sortable: true },
            ]

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina', name: 'vacina_abreviacao', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    fields.push({ key: 'vacinaSigla', label: 'Sigla da vacina', name: 'vacina_sigla', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina', name: 'vacina_sigla_nome', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina', name: 'vacina_sigla_abreviacao', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina', name: 'vacina_abreviacao_nome', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina', name: 'vacina_sigla_abreviacao_nome', searchable: true, sortable: true })
                    break;

                default:
                    fields.push({ key: 'vacinaNome', label: 'Nome da vacina', name: 'vacina_nome', searchable: true, sortable: true })
                    break;
            }

            fields.push({ key: 'estoque', label: 'Quantidade em estoque', name: 'estoque' },)

            if (this.verificarPermissao('create-imunizacao-baixa')) {
                fields.push({ class: 'col-min text-center', key: 'actions', label: 'Ações' })
            }

            return fields
        },
    },
    created() {
        this.repositories = {
            baixa: this.getConectaSusRepository('imunizacao.baixa')
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.baixa.index()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                    this.$refs.DataTableBaixa.search()
                })

        },
    },
    mixins: [ error, permissao, repository ],
    mounted() {
        this.load()
    },
}
</script>